import i18n from './index';

/** The four languages GeoNexora speaks, in the order the language picker shows them. */
export const LANGUAGES = ['nl', 'en', 'de', 'tr'] as const;
export type Language = (typeof LANGUAGES)[number];

export const LANGUAGE_NAMES: Record<Language, string> = {
  nl: 'Nederlands',
  en: 'English',
  de: 'Deutsch',
  tr: 'Türkçe',
};

const TAGS: Record<Language, string> = { nl: 'nl-NL', en: 'en-GB', de: 'de-DE', tr: 'tr-TR' };

/** The current language, reduced to one of ours. */
export function currentLanguage(): Language {
  const l = (i18n.language || 'en').substring(0, 2) as Language;
  return (LANGUAGES as readonly string[]).includes(l) ? l : 'en';
}

/** The BCP 47 tag numbers and dates are written in for the current language. */
export function localeTag(): string {
  return TAGS[currentLanguage()];
}
